import { useState } from 'react';
import { Icon } from '@timeedit/ui-components';
import { Modal, theme } from '@timeedit/ui-components/antd';

export const useDiscardConfirmation = (): [
  boolean,
  () => void,
  () => void,
  (callback: () => void) => void,
] => {
  const [open, setOpen] = useState(false);
  const [confirmFn, setConfirmFn] = useState(() => () => {});
  const confirmDiscardChanged = (callback: () => void) => {
    setConfirmFn(() => callback);
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return [open, onClose, confirmFn, confirmDiscardChanged];
};

export interface DiscardConfirmationProps {
  open: boolean;
  onClose: () => void;
  confirmFn: () => void;
}

const DiscardConfirmation = (props: DiscardConfirmationProps) => {
  const { open, onClose, confirmFn } = props;
  const { token } = theme.useToken();
  return (
    <Modal
      open={open}
      onOk={() => {
        onClose();
        confirmFn();
      }}
      onCancel={() => onClose()}
    >
      <Icon
        id="ExclamationCircleOutlined"
        alt="Exclamation Circle"
        style={{ color: token.colorWarning }}
      />{' '}
      <span className="te-ml-2">Your changes will be discarded</span>
    </Modal>
  );
};

export default DiscardConfirmation;
